<div class="flex flex-col items-center justify-center h-auto mt-16 text-center space-y-4">

    <img src="svg/hand.svg" class="h-20 w-20" alt="">
  <h1 class="my-4 text-dark-blue font-bold text-2xl">¡Bienvenido a Fincomercio!</h1>
  <p class="text-base text-black">Estamos emocionados de que hagas parte de nuestra Cooperativa.</p>

  <button class="btn-primary" [routerLink]="[nextRoute()]">
    Comenzar a Ahorrar
  </button>
  
  <button class="btn-secundary">
    Contactar un asesor
  </button>

    <span class="text-dark-blue underline cursor-pointer">Finalizar</span>

    <div class="h-auto w-full bg-light-blue text-black rounded-md flex items-center justify-center text-xs bg-green-50 shadow-md">
        <p class="m-0 w-full text-center py-3 text-xs">Puedes descargar el soporte de tu vinculación
          <span style="color: #003085; text-decoration: underline; cursor: pointer;">aquí</span>.
        </p>
    </div>

</div>

@if (showModalPap()) {
    <app-modal (closeModal)="showModalPap.set(false)">
        <div class="text-center flex flex-col items-center justify-center space-y-3.5 my-4">

            <img src="svg/pig.svg" class="h-16 w-16" alt="Pig">
            
            <p class="text-dark-blue font-bold text-lg">
                ¡Dale un impulso extra a tu dinero! <br>
                Abre tu ahorro programado
            </p>

            <p class="text-center text-base my-4 text-[14.5px]">
                Planea un ahorro extra al aporte social y camina hacia el cumplimiento de tus propósitos.
            </p>

            <button class="btn-primary" [routerLink]="[nextRoute()]">
                Abrir nuevo ahorro
            </button>
            
            <button class="btn-secundary" (click)="showModalPap.set(false)">
                No, gracias
            </button>
        </div>
    </app-modal>
}

@if (showModalInfo()) {
    <app-modal (closeModal)="showModalInfo.set(false)">
        <div class="text-center flex flex-col items-center justify-center space-y-3.5 my-4">

            <img src="img/invest.png" class="h-16 w-16" alt="Info">
            
            <p class="text-dark-blue font-bold text-lg">
                Información
            </p>

            <p class="text-center text-base my-4">
                Recuerda que el valor de tu vinculación es de ${{ valuesVinculation?.valueOne }} salvo que te encuentres en una campaña comercial. El valor de tu aporte mensual es ${{ valuesVinculation?.valueTwo }}.<br><br>

                Al ser asociado, tienes a favor un plan protección el cual  tiene costo de $11.000 (prevision $10.600 y seguro $ 400) cobrado después del tercer mes de vinculado.
            </p>

            <button class="btn-primary" (click)="showModalInfo.set(false)">
                Entendido
            </button>
        </div>
    </app-modal>

}